import { DataGrid, GridToolbarContainer, GridToolbarFilterButton, } from "@mui/x-data-grid";
import React, { useEffect, useState, useContext } from "react";
import { ExportIcon, UpAndDownArrow } from "./icons";
import { GridToolbar } from "@mui/x-data-grid-premium";
import { Search } from "./Search";
import LinearProgress from "@mui/material/LinearProgress";
import SortIcon from "./SortIcon";
import AuthContext from '../../context/AuthContext';

const MyTable = ({
    rows,
    columns,
		isRowSelectable , 
    handleSortModelChange = null,
    serverSearch = false,
    useSearch = false,
    useTopFilter = false,
    componentsProps = {},
    sortColumn = null,
    checkboxSelection = true,
    hideFooter = false,
    // disableRowSelectionOnClick = true,
    onRowSelectionModelChange = () => { },
    selectedRows = false,
    perPage = 100,
    paginationMode = "client",
    rowCount = 100,
    onPaginationModelChange = () => { },
    onePageOption = false,
    loading = false,
    onFilterChange = () => { },
    filterMode = "client",
    sortMode = null,
    sortType = false,
    minHeightRow = '40px',
    searchValue = '',
    onRowClick = () => { },
    onOpenModal = () => { },
    showHeader = true,
    setIsNightShift = () => { }
}) => {
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [query, setQuery] = useState("");
    const [newSelectedRows, setNewSelectedRows] = useState([])
    const { permission } = useContext(AuthContext);
    const [color, setColor] = useState(null);

    const OnQueryChange = (e) => {
        setQuery(e);
        // if (useSearch) {
        useSearch(e)
        // }
    };

    useEffect(() => {
        if (selectedRows) {
            setRowSelectionModel(selectedRows);
        }
    }, [selectedRows]);

    columns = columns.map((obj) => {
        if (obj.sort && obj.sort == false) {
            return obj;
        } else {
            return {
                ...obj,
                renderHeader: (params) => {
                    return (
                        <>
                            {" "}
                            <span style={obj?.style}>
                                {" "}
                                {obj.headerName}{" "}
                            </span>
                            <SortIcon
                                params={params}
                                sort={sortMode?.sort}
                                field={sortMode?.field}
                            />
                        </>
                    );
                },
            };
        }
    });

    const toolbarProps = {
        disableFilters: true,
    };

    let CustomToolbar = () => {
        return (
            <div className="d-flex justify-content-between no-print">
                {!serverSearch && !useSearch && <div></div>}
                {!serverSearch && useSearch && (
                    <Search value={query} onChange={OnQueryChange} />
                )}
                {serverSearch &&
                    <Search
                        value={searchValue}
                        onChange={(e) => {
                            serverSearch(e);
                        }}
                    />
                }
                <GridToolbarContainer
                    sx={{
                        display: "block",
                        textAlign: "end",
                        "& .MuiButton-startIcon": {
                            color: "#48535B",
                        },
                        "& .MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeSmall.MuiButton-textSizeSmall.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeSmall.MuiButton-textSizeSmall.css-1iyj4mk-MuiButtonBase-root-MuiButton-root":
                        {
                            color: "#48535B !important",
                        },
                    }}
                >
                    {useTopFilter ?
                        <>
                            <GridToolbarFilterButton />
                        </>
                        :
                        <></>
                    }
                </GridToolbarContainer>
            </div>
        );
    }
    let slots = {
        toolbar: useTopFilter
            ? () => (
                <GridToolbar
                    {...toolbarProps}
                    sx={{
                        display: "block",
                        textAlign: "end",
                        "& .MuiButton-startIcon": {
                            color: "#48535B",
                        },
                        "& .MuiButtonBase-root.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeSmall.MuiButton-textSizeSmall.MuiButton-root.MuiButton-text.MuiButton-textPrimary.MuiButton-sizeSmall.MuiButton-textSizeSmall.css-1iyj4mk-MuiButtonBase-root-MuiButton-root":
                        {
                            color: "#48535B !important",
                        },
                    }}
                />
            )
            : "",
    };
    let pageSizeInti = hideFooter ? 100 : perPage;
    let pageSizeArr = [5, 10, 25, 50, 100];

    if (onePageOption && perPage) {
        pageSizeArr = [perPage];
    }

    let slotsNew = {
        toolbar: CustomToolbar,
        loadingOverlay: LinearProgress,
        exportIcon: ExportIcon,
    }

    if (!showHeader) {
        slotsNew = {
            ...slotsNew,
            columnHeaders: () => null,
        }
    }

    const onNewSelection = (id, e = null) => {
        setColor(e);
        if (!permission || !permission.includes('Emp_Auth') ||
            (e != null && e.row.patch_id !== null && e.row.patch_id != undefined) || 
            (e?.row?.Batch_Number && e?.row?.page == 'fillShift') || 
            (e?.row?.id && typeof e?.row?.id == 'string' && e?.row?.id?.includes('SIGNUP')) || 
            (e.field == 'quickAssign') ||
            (e.row.page == 'position-list-fixes')
        ) 
        {
            setNewSelectedRows([id])
            setRowSelectionModel([id])
            onRowSelectionModelChange([id])
        } else {
            let tempArr = [...newSelectedRows]
            if (tempArr.includes(id)) {
                const index = tempArr.indexOf(id)
                tempArr.splice(index, 1)
            } else {
                tempArr.push(id)
            }
            setNewSelectedRows(tempArr)
            onRowSelectionModelChange(tempArr)
        }
    }

    return (
        <>
            <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: pageSizeInti },
                    },
                }}
                pageSizeOptions={pageSizeArr}
                // disableRowSelectionOnClick={disableRowSelectionOnClick}
                // onRowSelectionModelChange={onRowSelectionModelChange}
                rowSelectionModel={rowSelectionModel}
                onPaginationModelChange={onPaginationModelChange}
                // slots={slots}
                AutoGenerateColumns="True"
                // filterMode='server'
                filterMode={filterMode}
                onFilterModelChange={onFilterChange}
                paginationMode={paginationMode} /////'server'
                rowCount={rowCount}
                // sortingMode={handleSortModelChange ? "server" : "client"}
                sortingMode={sortType ? "server" : "client"}
                onSortModelChange={handleSortModelChange}
                componentsProps={componentsProps}
                checkboxSelection={checkboxSelection}
                slots={slotsNew}
                hideFooter={hideFooter}
                loading={loading}
                className="fs-16"
                sx={{
                    " & .MuiDataGrid-overlayWrapper": {
                        minHeight: "17px",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        overflowY: 'visible !important',
                        scrollbarWidth: 'none !important'
                    },
                    "& .MuiTablePagination-selectLabel": {
                        margin: '0px'
                    },
                    "& .MuiTablePagination-displayedRows": {
                        margin: '0px'
                    },
                    "& .MuiDataGrid-cell": {
                        fontSize: '14px',
                        overflow: 'unset !important'
                    },
                    "& .form-select": {
                        fontSize: '14px'
                    },
                    "& .MuiSvgIcon-root": {
                        transition: 'none !important',
                    },
                    // ".MuiDataGrid-cell": {
                    //     padding: '6px 0px !important',
                    // },
                    ".MuiDataGrid-overlayWrapperInner": {
                        height: '15px !important'
                    },
                    ".MuiDataGrid-overlay": {
                        marginTop: '10px'
                    },
										".disabled-row" : {
											pointerEvents: 'none' ,   
										},
                }}
                // getEstimatedRowHeight={() => 100}
                getRowClassName={(params) => params?.row?.addSeparator && 'separator-class' || ((params?.row?.Status == 'F' && params?.row?.page == 'fillShift') && 'disabled-row')}
                // getRowHeight={() =>  minHeightRow}

								getRowHeight={(params) => {
									const filledCount = params?.model?.Position_Filled?.length ?? 0;
									const myTeamHeight = params?.model?.heightOfRow == 'myTeamTableHeight' && params?.model?.overtime_shifts?.length > 1 
									return filledCount > 1 ? 'auto' : myTeamHeight ? 'auto' : minHeightRow;
								}}

                localeText={{ noRowsLabel: "No results found." }}
								isRowSelectable={isRowSelectable}
                onRowClick={onRowClick}
                onCellClick={(e) => {
                    if (permission && permission.includes('Emp_Auth') && (e.field == 'inDayShift' || e.field == 'inNIGHTShift')) {
                        if (e.field == 'inNIGHTShift') {
                            setIsNightShift(true)
                        }
                        else if (e.field == 'inDayShift') {
                            setIsNightShift(false)
                        }
                        onOpenModal(e)
                    }
                    else {
                        onNewSelection(e.id, e)
                    }
                }}
								// getRowId={(row) => row?.id ? row?.id : row?.employee?.Emp_Code ? row?.employee?.Emp_Code : row?.id}
                
								getRowId={(row) => row?.list_hours ? row?.id : row?.employee?.Emp_Code ? row?.employee?.Emp_Code : row?.id}
                
								// getRowId={(row) => {
                //     if (row?.employee?.Emp_Code) {
                //       return row?.employee?.Emp_Code;
                //     } 
                //     else if (row?.Emp_Code) {
                //         return row?.Emp_Code;
                //     } 
                //     else {
                //       return row.id;
                //     }
                // }}
            />
        </>
    );
};

export default MyTable;
